var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinkTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.063,
    height: 28.063,
    viewBox: "0 0 28.063 28.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_tick-circle",
    "data-name": "vuesax/outline/tick-circle",
    transform: "translate(-748 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle",
    transform: "translate(748 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.57,25.14A12.57,12.57,0,1,1,25.14,12.57,12.58,12.58,0,0,1,12.57,25.14Zm0-23.386A10.816,10.816,0,1,0,23.386,12.57,10.829,10.829,0,0,0,12.57,1.754Z",
    transform: "translate(1.462 1.462)",
    fill: "#cc006e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.183,8.381a.876.876,0,0,1-.62-.257L.254,4.815A.876.876,0,0,1,1.494,3.575L4.183,6.264l6.01-6.01a.876.876,0,1,1,1.239,1.239L4.8,8.124A.876.876,0,0,1,4.183,8.381Z",
    transform: "translate(8.188 9.837)",
    fill: "#cc006e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H28.063V28.063H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkTick);
export default __webpack_public_path__ + "static/media/pink-tick.19a7338635e36f8c74877da713fe0a6e.svg";
export { ForwardRef as ReactComponent };